module.exports = __webpack_public_path__ + "static/DSC_9487-9d4b4df8f58607121be24f839c4f06ed.jpg";